<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<a *ngIf="badgeUrl" href="{{ badgeUrl }}">
  <img class="img-fluid" src="{{ badgeUrl }}/badge" alt="cii-badge" />
</a>
